const baseContent = {
  type: "",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "words",
    file: {},
    isUpdated: false,
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: true,
    isUpdated: false,
  },
};

const createWordEntry = (title: string, key: string, value: string) => ({
  title,
  content: {
    ...baseContent,
    data: {
      ...baseContent.data,
      id: "",
      key,
      value,
      type: "words",
      file: {},
      isUpdated: false,
    },
    translation: {
      ...baseContent.translation,
      id: "",
      name: "",
      translationableId: "",
      translationableType: "Resource",
      adminId: "",
      languageId: "",
      flag: true,
      isUpdated: false,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: false,
});

const wordEntries: { title: string, key: string, value: string }[] = [
  { title: "Category", key: "categories", value: "Categories" },
  { title: "Players", key: "players", value: "Players" },
  { title: "Restarts", key: "restarts", value: "Restarts" },
  { title: "Contributors", key: "Contributors", value: "Contributors" },
  { title: "Shares", key: "shares_word", value: "Shares" },
  { title: "Self Pick Button Description", key: "skip", value: "Self Pick Button Description" },
  { title: "Result", key: "result", value: "Result" },
  { title: "Results", key: "results", value: "Results" },
  { title: "You Won!", key: "you_won", value: "You Won!" },
  { title: "Enter Url", key: "enterUrl", value: "Enter Url" },
  { title: "Rate", key: "rate", value: "Rate" },
  { title: "Comment", key: "comment", value: "Comment" },
  { title: "Prizes", key: "prizes", value: "Prizes" },
  { title: "Details", key: "details", value: "Details" },
  { title: "Donate", key: "donate", value: "Donate" },
  { title: "Product Images", key: "productImages", value: "Product Images" },
  { title: "Product Name", key: "productName", value: "Product Name" },
  { title: "Price", key: "price", value: "Price" },
  { title: "Website", key: "website", value: "Website" },
  { title: "Select Category", key: "selectCategory", value: "Select Category" },
  { title: "About Us", key: "aboutUsTranslaton", value: "About Us" },
  { title: "Private", key: "private", value: "Private" },
  { title: "Sound", key: "sound", value: "Sound" },
  { title: "New Games", key: "newGames", value: "New Games" },
  { title: "Content Added", key: "contentAdded", value: "Content Added" },
  { title: "New Messages", key: "newMessages", value: "New Messages" },
  { title: "Leaderboard", key: "leaderboardTranslation", value: "Leaderboard" },
  { title: "Prize Alert", key: "prizeAlert", value: "Prize Alert" },
  { title: "Similar Games", key: "similarGames", value: "Similar Games" },
  { title: "Activity", key: "activity", value: "Activity" },
  { title: "Player", key: "player", value: "Player" },
  { title: "Prize", key: "prize", value: "Prize" },
  { title: "Reward", key: "reward", value: "Reward" },
  { title: "Similar Game", key: "similarGame", value: "Similar Game" },
  { title: "NO WINS AVAILABLE", key: "noWinsAvailable", value: "NO WINS AVAILABLE" },
  { title: "NO SHARES AVAILABLE", key: "noSharesAvailable", value: "NO SHARES AVAILABLE" },
  { title: "NO REWARDS AVAILABLE", key: "noRewardsAvailable", value: "NO REWARDS AVAILABLE" },
  { title: "NO SURVEYS AVAILABLE", key: "noSurveysAvailable", value: "NO SURVEYS AVAILABLE" },
  { title: "NO GAME AVAILABLE", key: "noGameAvailable", value: "NO GAME AVAILABLE" },
  { title: "NO MESSAGES AVAILABLE", key: "noMessagesAvailable", value: "NO MESSAGES AVAILABLE" },
  { title: "CLAIM YOUR PRIZE", key: "claimYourPrize", value: "CLAIM YOUR PRIZE" },
  { title: "WAIT FOR DRAW", key: "waitForDraw", value: "WAIT FOR DRAW" },
  { title: "PICK 6 EMOJIS", key: "pickSixEmojis", value: "PICK 6 EMOJIS" },
  { title: "PLAY NOW", key: "playNow", value: "PLAY NOW" },
  { title: "Enter Free", key: "enterFreeText", value: "Enter Free" },
  { title: "Agree", key: "agree", value: "Agree" },
  // JUNE27 p25-30 (3.5): the AutoMatch OPTIONS modal title was a hard-coded
  // English <Text>, the only untranslated label on that screen.
  { title: "OPTIONS", key: "options", value: "OPTIONS" },
  // JUNE27 p58-60 (3.10): the tie-breaker title was bound to `playADFree`,
  // the AutoMatch key, so editing it here changed the wrong screen; "Spin
  // Win" was hard-coded English with no key at all.
  { title: "Tie Breaker Title", key: "tieBreakerTitle", value: "BREAK\nTHE TIE" },
  { title: "Spin Win", key: "spinWin", value: "Spin Win" },
  // JUNE27 p43 (3.8): the submitted-emojis Go Back tab was reading the
  // unrelated `design` key (copy-paste error) with 'Go Back' as fallback.
  { title: "Go Back", key: "goBack", value: "Go Back" },
];

const words = wordEntries.map(({ title, key, value }) => createWordEntry(title, key, value));
export { words };








